// An alert threshold has to be above 0 and strictly below the stock on hand,
// otherwise the low-stock alert would fire the moment it is saved (or never).
// Returns "" when valid or nothing has been typed yet.
//
// wholeUnits: finished goods are counted in whole pieces, so a stock of 1
// leaves no valid threshold. Raw materials can hold decimals (e.g. 37.5 m),
// where only a stock of 0 leaves none.
export const getThresholdError = (rawValue, stock, { wholeUnits = true } = {}) => {
  if (rawValue === undefined || rawValue === "") return "";
  if (stock <= (wholeUnits ? 1 : 0)) return `Stock trop faible (${stock}) pour définir un seuil.`;
  const value = Number(rawValue);
  if (Number.isNaN(value)) return "Valeur invalide.";
  if (value <= 0) return "Le seuil doit être supérieur à 0.";
  if (value >= stock) return `Le seuil doit être inférieur au stock (${stock}).`;
  return "";
};
